export default {
    howToTeach: '如何上课',

    trialClass: '申请试听课',
    trialClass_step1: '注册领取价值188元的试听课',
    trialClass_step2: '注册后我们会尽快与您联系',
    trialClass_step3: '立即申请',

    download: '下载课堂客户端',
    download_site: '下载地址',
    download_site_title: '哈兔PC客户端',
    download_site_intro: '使用哈兔客户端上课，让您的在线课程体验更高效、便捷、稳定。',
    download_site_b1: 'Mac',
    download_site_b2: 'Windows',
    download_site_app: '哈兔移动端',
    download_site_b3: 'APP下载',

    download_site_install: '安装',

    download_site_system: '系统要求',
    download_site_support1: '不支持XP系统，要求Mac10.10或Windows 7.0以上',
    download_site_support2: 'iOS 9.0 以上',

    login: '使用客服提供的试听账号登录课堂客户端',
    login_intro: '巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉巴拉',

    device: '设备要求',
    device_suit1: 'PC电脑+摄像头+耳麦',
    device_suit2: '笔记本电脑（内置或外置摄像头）+耳麦',
    device_suit3: 'iPad',
};